
namespace SP {
    export enum PicklistBarcodePreference {
        All = 1,
        OnlyWithBarcode = 2,
        OnlyWithoutBarcode = 3
    }
}


